export const locale = {
    lang: 'ru',
    data: {
        HEADER: {
            'MEGA_MENU': 'Mега Меню',
            'QUICK_LINK': 'Quick Link',
        },
        SIDENAV: {
            DASHBOARDS: 'Админ панелы',
            MAILBOX: 'Почта',
            CHAT: 'Чат',
            KNOWLADGE_BASE: 'База знаний',
            CALENDAR: 'Календарь',
            CONTACTS: 'Контакты',
        },
    }
};
